require.register("modules/mex/mex-activity/page-9/page-9", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_9 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_9;


  
});

